import { render } from "./SPRINT_REVIEW_COMPLETED.vue?vue&type=template&id=370f12cc&ts=true"
import script from "./SPRINT_REVIEW_COMPLETED.vue?vue&type=script&lang=ts"
export * from "./SPRINT_REVIEW_COMPLETED.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__